"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.iterator");
require("core-js/modules/es6.object.to-string");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.function.name");
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} return target; }
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = __importDefault(require("@theme"));
const _theme_2 = require("@theme");
const _utils_1 = require("@utils"); // Component
var InputCheckbox = function InputCheckbox(_ref) {
    var _ref$outline = _ref.outline, outline = _ref$outline === void 0 ? false : _ref$outline, children = _ref.children, name = _ref.name, onChange = _ref.onChange, required = _ref.required, checked = _ref.checked, _ref$largeLabel = _ref.largeLabel, largeLabel = _ref$largeLabel === void 0 ? false : _ref$largeLabel, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, className = _ref.className, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, props = _objectWithoutPropertiesLoose(_ref, ["outline", "children", "name", "onChange", "required", "checked", "largeLabel", "disabled", "className", "size"]);
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, {
        className: className,
        disabled: disabled,
        size: size
    }, /*#__PURE__*/ react_1.default.createElement(Box, {
        size: size
    }, /*#__PURE__*/ react_1.default.createElement(Input, Object.assign({
        type: "checkbox"
    }, props, {
        name: name,
        onChange: onChange,
        checked: checked,
        disabled: disabled
    }, {
        required: !!required
    })), /*#__PURE__*/ react_1.default.createElement(Checkmark, {
        outline: outline,
        size: size
    })), /*#__PURE__*/ react_1.default.createElement(Label, {
        largeLabel: largeLabel
    }, children));
}; // Styling
var Wrapper = styled_components_1.default.label.withConfig({
    displayName: "InputCheckbox__Wrapper",
    componentId: "jgnyx7-0"
})(["position:relative;display:flex;align-items:", ";padding:", "px 0;user-select:none;cursor:", ";opacity:", ";", " &:hover input ~ span{", ";}& input:checked ~ span{background-color:", ";&:after{transform:rotate(45deg) scale3d(1,1,1);opacity:1;}}"], function (props) {
    return props.size === 'medium' ? 'center' : 'flex-start';
}, function (props) {
    return props.size === 'medium' ? 16 : 0;
}, function (props) {
    return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
    return props.disabled ? 0.32 : 1;
}, _theme_1.default.type.pSmallSans, _utils_1.rgba(_theme_2.palette.snow, 0.8), _theme_2.palette.snow);
var Box = styled_components_1.default.div.withConfig({
    displayName: "InputCheckbox__Box",
    componentId: "jgnyx7-1"
})(["flex:0 0 auto;position:relative;width:", ";height:", ";margin-right:", ";@media only screen and (min-width:", "){width:32px;height:32px;margin-right:24px;}@media only screen and (min-width:", "){width:40px;height:40px;}"], function (props) {
    return props.size === 'medium' ? '24px' : '16px !important';
}, function (props) {
    return props.size === 'medium' ? '24px' : '16px !important';
}, function (props) {
    return props.size === 'medium' ? '16px' : '8px !important';
}, _theme_2.breakpoint.laptop, _theme_2.breakpoint.desktop);
var Input = styled_components_1.default.input.withConfig({
    displayName: "InputCheckbox__Input",
    componentId: "jgnyx7-2"
})(["position:absolute;opacity:0;height:0;width:0;"]);
var Checkmark = styled_components_1.default.span.withConfig({
    displayName: "InputCheckbox__Checkmark",
    componentId: "jgnyx7-3"
})(["position:absolute;top:0;left:0;background-color:", ";width:100%;height:100%;border:1px solid ", ";border-radius:50%;", " appearance:none;transition:background-color 0.25s ease-in-out;&:after{position:absolute;", " display:block;border:solid ", ";transform:rotate(45deg) scale3d(0,0,1);opacity:0;content:'';transition:opacity 0.25s ease-in-out,transform 0.6s cubic-bezier(0.44,1.86,0.74,1);@media only screen and (min-width:", "){left:calc(50% - 3px);top:calc(50% - 7.5px);width:6px;height:12px;border-width:0 2.5px 2.5px 0;}}"], _utils_1.rgba(_theme_2.palette.snow, 0), function (props) {
    return props.outline ? _theme_2.palette.ink : _theme_2.palette.snow;
}, function (props) {
    return !props.outline && "\n    box-shadow: 0.5px 1px 0px rgba(0, 0, 0, 0.16);\n  ";
}, function (props) {
    return props.size !== 'small' ? "\n        left: calc(50% - 2.5px);\n        top: calc(50% - 6.5px);\n        width: 5px;\n        height: 10px;    \n        border-width: 0 2px 2px 0;\n        " : "\n        left: calc(50% - 1px) !important;\n        top: calc(50% - 4px) !important;\n        width: 3px !important;\n        height: 7px !important;\n        border-width: 0 1.5px 1px 0 !important;\n        ";
}, _theme_2.palette.ink, _theme_2.breakpoint.laptop);
var Label = styled_components_1.default.span.withConfig({
    displayName: "InputCheckbox__Label",
    componentId: "jgnyx7-4"
})(["display:block;max-width:280px;", " ", " & a{position:relative;display:inline-flex;margin:0 1px;color:", ";overflow:hidden;&::after{z-index:2;position:absolute;bottom:0;left:0;background-color:", ";width:100%;height:1px;transform:translate3d(-100%,0,0);transition:color 0.25s ease-in-out,transform 0.35s ease-in-out;content:'';pointer-events:none;}&:hover{&::after{transform:translate3d(0,0,0);}}}@media only screen and (min-width:", "){max-width:300px;}@media only screen and (min-width:", "){max-width:320px;}"], function (props) {
    return props.largeLabel ? 'max-width: 100% !important;' : '';
}, function (props) {
    return props.largeLabel ? _theme_2.type.label : _theme_2.type.pSmallSans;
}, _theme_2.palette.rose, _utils_1.rgba(_theme_2.palette.rose, 0.64), _theme_2.breakpoint.laptop, _theme_2.breakpoint.desktop); // Typing
exports.default = InputCheckbox;
